import { navigate } from 'gatsby';
import getDefaultSearchFromUrl from 'utils/globals/getDefaultSearchFromUrl';
import hasWindow from 'utils/globals/hasWindow';

class FilterService {
  reset() {
    if (!hasWindow()) return;

    const url = new URL(window.location.href);
    url.search = '';

    navigate('?');
  }
  toURL(obj: Record<string, string[]>) {
    if (!hasWindow()) return;

    const url = new URL(window.location.href);
    url.search = '';
    Object.entries(obj).forEach(([key, arr]) => {
      if (typeof arr === 'string') url.searchParams.append(key, arr);
      else if (Array.isArray(arr))
        arr.forEach((value) => {
          url.searchParams.append(key, value);
        });
    });
    navigate(url.search === '' ? '?' : url.search);
  }
  removeFilter(key, value) {
    if (!hasWindow()) return;

    const url = new URL(window.location.href);

    url.search = url.search
      .replace(`${key}=${value}`, '')
      .replaceAll('&&', '&')
      .replaceAll('?&', '?');

    navigate(url.search === '' ? '?' : url.search);
  }
  fromURl() {
    if (!hasWindow()) return {};

    return {
      collections: getDefaultSearchFromUrl('collections'),
      shapes: getDefaultSearchFromUrl('shapes'),
      colors: getDefaultSearchFromUrl('colors'),
      ages: getDefaultSearchFromUrl('ages'),
      promotion: getDefaultSearchFromUrl('promotion'),
    };
  }
}

export default new FilterService();
